/**
 * Revenue API service for PJO (Jet Partner/Airliner) revenue management.
 */
import api from './api';

const revenueService = {
  /**
   * Get revenue report for the authenticated airliner.
   * @param {Object} params - Query parameters
   * @param {string} params.dateFrom - Start date (YYYY-MM-DD)
   * @param {string} params.dateTo - End date (YYYY-MM-DD)
   * @param {number} params.aircraftId - Filter by aircraft ID (optional)
   * @param {string} params.departureAirport - Filter by departure airport IATA (optional)
   * @param {string} params.arrivalAirport - Filter by arrival airport IATA (optional)
   * @returns {Promise<Object>} Revenue report data
   */
  getRevenueReport: async (params = {}) => {
    const response = await api.get('/revenue', { params });
    return response;
  },

  /**
   * Export revenue report as CSV.
   * @param {Object} params - Same as getRevenueReport
   * @returns {Promise<Blob>} CSV file blob
   */
  exportCSV: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const url = `/revenue/export/csv${queryString ? `?${queryString}` : ''}`;
    
    // Use fetch for blob response
    const token = sessionStorage.getItem('token');
    const baseURL = process.env.REACT_APP_API_BASE_URL || 'https://jetscanner360.com/api/v1';
    
    const response = await fetch(`${baseURL}${url}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to export CSV');
    }

    return response.blob();
  },

  /**
   * Export revenue report as PDF.
   * @param {Object} params - Same as getRevenueReport
   * @returns {Promise<Blob>} PDF file blob
   */
  exportPDF: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const url = `/revenue/export/pdf${queryString ? `?${queryString}` : ''}`;
    
    // Use fetch for blob response
    const token = sessionStorage.getItem('token');
    const baseURL = process.env.REACT_APP_API_BASE_URL || 'https://jetscanner360.com/api/v1';
    
    const response = await fetch(`${baseURL}${url}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to export PDF');
    }

    return response.blob();
  },
};

export default revenueService;
